/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AuctionInputs */

const cs_enum_auction = /** @type {(inputs: Enum_AuctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dražba`)
};

const en_enum_auction = /** @type {(inputs: Enum_AuctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction`)
};

/**
* | output |
* | --- |
* | "Auction" |
*
* @param {Enum_AuctionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_auction = /** @type {((inputs?: Enum_AuctionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AuctionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_auction(inputs)
	return cs_enum_auction(inputs)
});